<!-- modal delete -->
<div class="modal fade" id="{{idmodal}}" role="dialog" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{title}} - Delete</h4>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <table class="tbl-delete">
            <caption class="caption"></caption>
            <thead>
            <th style="background-color: white;height: 0px;" colspan="2"></th>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>
                    You want to delete "{{title}}". Are you sure ?
                  </p>
                </td>
              </tr>
              <tr>
                <td>Market company</td>
                <td>
                  <select class="form-control-modal deletemodal" required id="selectedMarketCoToDeleteid"
                          [(ngModel)]="selectedMarketCoToDelete" (ngModelChange)="SelectedMarketCoToDelete($event)">
                    <option *ngFor="let mco of marketcompaniesToDelete"
                            [ngValue]="mco">
                      {{mco.marketCompanyName}}
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-color2 btn-right" data-bs-dismiss="modal">Cancel</button>
        <button type="button" (click)="DeleteParam()" class="btn btn-color2 btn-right" data-bs-dismiss="modal">Confirm</button>
      </div>
    </div>
  </div>
</div>
